<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-question-form :id="parseInt(this.$route.params.id)">

      </edit-question-form>
    </div>
  </div>
</template>
<script>
  import EditQuestionForm from './BGEditQuestionForm.vue'

  export default {
    components: {
      EditQuestionForm
    },
    created () {
      this.$log.debug('BGQuestion.created ' + this.$route.params.id)
    },
    beforeCreate () {
      this.$log.debug('BGQuestion.beforeCreate ' + this.$route.params.id)
    },
    mounted () {
      this.$log.debug('BGQuestion.mounted ' + this.$route.params.id)
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGQuestion.vue